import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild, input } from '@angular/core';
import { CompensationDeviationTendancy } from '../../enums/compensation-deviation-tendancy.enum';
import { CompensationDeviationHelper } from '../../helpers/compensation-deviation.helper';

@Component({
  selector: 'customer-compensation-deviation',
  templateUrl: './compensation-deviation.component.html',
  styleUrls: ['./compensation-deviation.component.scss'],
  standalone: false
})
export class CompensationDeviationComponent implements OnInit, AfterViewChecked {
  @ViewChild('belowIndicator') belowIndicator: ElementRef;
  @ViewChild('aboveIndicator') aboveIndicator: ElementRef;
  @ViewChild('indicatorWrapper') indicatorWrapper: ElementRef;

  /** defines the distribution of one gender. male distribution >= 0, female distribution <= 0; values between -1 and 1 */
  readonly distribution = input.required<number>();

  public tendency: CompensationDeviationTendancy;
  public percentage: number;

  public get isBelowExpectations(): boolean {
    return [
      CompensationDeviationTendancy.HugeGapBelow,
      CompensationDeviationTendancy.SmallGapBelow,
      CompensationDeviationTendancy.InExpectationBelow
    ].includes(this.tendency);
  }

  public get isAboveExpectations(): boolean {
    return [
      CompensationDeviationTendancy.HugeGapAbove,
      CompensationDeviationTendancy.SmallGapAbove,
      CompensationDeviationTendancy.InExpectationAbove
    ].includes(this.tendency);
  }

  public get isInsideExpectations(): boolean {
    return [
      CompensationDeviationTendancy.InExpectationAbove,
      CompensationDeviationTendancy.InExpectationBelow
    ].includes(this.tendency);
  }

  public get hasSmallDiff(): boolean {
    return [CompensationDeviationTendancy.SmallGapAbove, CompensationDeviationTendancy.SmallGapBelow].includes(
      this.tendency
    );
  }

  public get hasHugeDiff(): boolean {
    return [CompensationDeviationTendancy.HugeGapAbove, CompensationDeviationTendancy.HugeGapBelow].includes(
      this.tendency
    );
  }

  public get warningText(): string {
    return CompensationDeviationHelper.getWarningTranslationKey(this.distribution()) ?? '';
  }

  public get expectationText(): string {
    if (this.hasHugeDiff && this.isBelowExpectations) {
      return 'merit-budget.hr-research.compensation-deviation.huge-gap-below';
    }

    if (this.hasSmallDiff && this.isBelowExpectations) {
      return 'merit-budget.hr-research.compensation-deviation.small-gap-below';
    }

    if (this.isInsideExpectations) {
      return 'merit-budget.hr-research.compensation-deviation.in-expectations';
    }

    if (this.hasSmallDiff && this.isAboveExpectations) {
      return 'merit-budget.hr-research.compensation-deviation.small-gap-above';
    }

    if (this.hasHugeDiff && this.isAboveExpectations) {
      return 'merit-budget.hr-research.compensation-deviation.huge-gap-above';
    }

    return '';
  }

  public ngOnInit(): void {
    this.percentage = this.distribution();
    this.tendency = CompensationDeviationHelper.getTendency(this.percentage);
  }

  public ngAfterViewChecked(): void {
    const fullIndicatorWidth = this.indicatorWrapper.nativeElement.getBoundingClientRect().width;
    if (fullIndicatorWidth > 0) {
      if (this.isBelowExpectations) {
        this.belowIndicator.nativeElement.style.width = `${this.percentage * 3 * -1}%`;
      } else if (this.isAboveExpectations) {
        this.aboveIndicator.nativeElement.style.width = `${this.percentage * 3}%`;
      } else {
        this.aboveIndicator.nativeElement.style.width = 0;
      }
    }
  }
}
